export const APP_VERSION = 'v1.0.17'; // Phiên bản app, tăng version khi deploy
export const CACHE_VERSION = 'laido-cache-v1.0.17'; // Version cache, phải khớp với CACHE_NAME trong serviceWorker.js 